import { isMobile  } from '@utils/index.js'
export class RechargeSwiper {
    constructor() {
        this.init();
    }
    init() {
        new Swiper(".recharge-swiper", {
            spaceBetween: 20,
            slidesPerView: 1.6,
            slideToClickedSlide: true,
            autoplay: false,
            freeMode: !isMobile(),
            speed: isMobile() ? 600 : 3000,
            loop: isMobile(),
            breakpoints: {
                1024: {
                    spaceBetween: 20,
                    slidesPerView: 5,
                },
            },
            pagination: {
                el: ".recharge-pagination",
            },
        });
    }
}
